"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumRfiInterstitialData = void 0;
const actions_constants_1 = require("./actions.constants");
const PAGE_NAME = 'updateDocumentationModal';
exports.TealiumRfiInterstitialData = {
    [actions_constants_1.RFI_INTERSTITIAL_OPEN_MODAL]: {
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.MODAL,
        component: actions_constants_1.TealiumComponent.RFI_MODAL,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.UPDATE_RFI_MODAL,
        eventLabel: 'open',
    },
    [actions_constants_1.RFI_INTERSTITIAL_CROSS_ICON]: {
        action: actions_constants_1.TealiumAction.CLOSE,
        format: actions_constants_1.TealiumFormat.ICON,
        component: actions_constants_1.TealiumComponent.RFI_MODAL,
        element: actions_constants_1.TealiumElement.CROSS,
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.UPDATE_RFI_MODAL,
        eventLabel: 'close',
    },
    [actions_constants_1.RFI_INTERSTITIAL_CANCEL_LINK]: {
        action: actions_constants_1.TealiumAction.CLICK,
        format: actions_constants_1.TealiumFormat.LINK,
        component: actions_constants_1.TealiumComponent.RFI_MODAL,
        element: 'updateLater',
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'updateLaterLink',
    },
    [actions_constants_1.RFI_INTERSTITIAL_GO_TO_PROFILE_BUTTON]: {
        action: actions_constants_1.TealiumAction.CLICK,
        format: actions_constants_1.TealiumFormat.BUTTON,
        component: actions_constants_1.TealiumComponent.RFI_MODAL,
        element: 'uploadNow',
        pathName: '/profile/legal-documentation',
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_BUTTON,
        eventLabel: 'uploadNowButton',
    },
};
//# sourceMappingURL=tealium.js.map